import React, { useEffect, useRef } from 'react'
import t from 'prop-types'
import { IconClose } from 'ui'
import { useTransition } from 'react-spring'

import { useWindowSize } from '@react-hook/window-size/throttled'

import { Overlay, Wrapper, CloseButton, Label } from './components'

const SPALLA_SCRIPT_URL = 'https://beyond.spalla.io/player/js/spalla.player.js'

const loadSpallaScript = (() => {
  let scriptLoaded = false

  return () => {
    return new Promise((resolve, reject) => {
      if (scriptLoaded || window.Spalla) {
        resolve()
        return
      }

      const script = document.createElement('script')
      script.src = SPALLA_SCRIPT_URL
      script.async = true
      script.onload = () => {
        scriptLoaded = true
        resolve()
      }
      script.onerror = reject
      document.body.appendChild(script)
    })
  }
})()

const PlayerModal = ({ id, visible, onClose }) => {
  const transitions = useTransition(visible, null, {
    from: { position: 'fixed', opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })
  const containerId = `spalla-player-${id}`

  const playerContainerRef = useRef(null)

  const [width] = useWindowSize()

  const playerRef = useRef(null)

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.code === 'KeyS' && visible) {
        onClose()
      }
    }

    document.addEventListener('keypress', handleKeyPress)
    return () => document.removeEventListener('keypress', handleKeyPress)
  }, [onClose, visible])

  // function handleKeyPress (event) {
  //   if (event.code === 'KeyS' && visible) {
  //     onClose()
  //   }
  // }

  useEffect(() => {
    if (!id || !visible) return

    loadSpallaScript().then(() => {
      const el = playerRef.current
      if (!el) return

      if (!document.getElementById(containerId)) {
        const playerDiv = document.createElement('div')
        playerDiv.id = containerId
        el.appendChild(playerDiv)
      }

      try {
        const player = new window.SpallaPlayer(containerId, {
          videoId: id,
          width: '100%',
          height: '100%',
          autoplay: false,
          bar: true,
          muted: false,
          subtitlePosition: 'inner',
          subtitleLanguage: null,
          resume: false,
          info: false,
          enableLikes: true,
          enableCc: true,
          playbackSpeeds: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 3, 4],
          controls: [
            'play',
            'pause',
            'time',
            'live',
            'seekbar',
            'volume',
            'quality',
            'speed',
            'subtitles',
            'fullscreen',
            'forward',
            'backward',
            'settings',
            'cast',
          ],
        })
        player.on('ready', () => {
        })

        player.on('*', (e) => {
        })
      } catch (error) {
        console.error(error)
      }
    })
  }, [containerId, id, visible])

  return transitions.map(({ item, props, key }) =>
    item ? (
      <Overlay key={key} style={props} onClick={() => onClose()}>
        <Wrapper onClick={(e) => e.stopPropagation()}>
          <Label>Pressione "S" para sair</Label>
          <CloseButton onClick={onClose}>
            <IconClose size={24} />
          </CloseButton>
          <div
            ref={playerRef}
            style={{
              // paddingTop: '56.25%',
              position: 'relative',
              width: width > 900 && '700px',
              height: '100%',
            }}
          >
            <div
              ref={playerContainerRef}
              id={containerId}
              style={{ width: '100%', height: width > 900 ? '600px' : '300px' }}
              className='spalla-player'
            />
          </div>
        </Wrapper>
      </Overlay>
    ) : null
  )
}

PlayerModal.propTypes = {
  id: t.string,
  visible: t.bool.isRequired,
  onClose: t.func.isRequired,
}

export { PlayerModal }
